import { AuthFormProps } from './type';

export const AuthForm = ({ children, onSubmit, classNames = '', ...props }: AuthFormProps) => (
    <form className={`${classNames}`} onSubmit={onSubmit} {...props}>
        {children}
    </form>
);
